/**
 * MY BUTCHER BOX — Box Discount Engine v2.0
 * Adapted for Roar/HaloRoar theme
 */
(function() {
  'use strict';

  var CONFIG = {
    tiers: [
      { min: 14000, max: Infinity, percent: 15, label: '-15%', next: null, code: 'BOX-TIER3' },
      { min: 8000, max: 13999, percent: 10, label: '-10%', next: 14000, code: 'BOX-TIER2' },
      { min: 5000, max: 7999, percent: 5, label: '-5%', next: 8000, code: 'BOX-TIER1' }
    ],
    allCodes: ['BOX-TIER1', 'BOX-TIER2', 'BOX-TIER3'],
    boxProductType: 'Box',
    currencySymbol: '€',
    selectors: {
      productPrice: '.product-item .product-item__price .price',
      miniCartItems: '.minicart .cart__item',
      miniCartTotal: '.minicart .cart__total .price',
      progressBar: '#mbb-tier-progress',
      addonDrawer: '#mbb-addon-drawer'
    }
  };

  var state = { tier: null, maxBoxPrice: 0, cart: null, lastSyncedCode: null, syncInFlight: false };

  function formatPrice(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' ' + CONFIG.currencySymbol;
  }

  function formatPriceHTML(cents) {
    return '<span class="money"><span class="currency_symbol">' +
      CONFIG.currencySymbol + '</span>' +
      (cents / 100).toFixed(2).replace('.', ',') + '</span>';
  }

  function fetchCart(callback) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root : '/';
    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) { state.cart = cart; callback(cart); })
      .catch(function(e) { console.warn('[MBB Engine] Cart fetch error:', e); });
  }

  function calculateTier(cart) {
    state.maxBoxPrice = 0;
    if (!cart || !cart.items) return null;
    cart.items.forEach(function(item) {
      var isBox = (item.product_type === CONFIG.boxProductType || item.product_type === CONFIG.boxProductType.toLowerCase());
      if (isBox && item.price > state.maxBoxPrice) { state.maxBoxPrice = item.price; }
    });
    for (var i = 0; i < CONFIG.tiers.length; i++) {
      var t = CONFIG.tiers[i];
      if (state.maxBoxPrice >= t.min && state.maxBoxPrice <= t.max) return t;
    }
    return null;
  }

  function extractCents(text) {
    if (!text) return 0;
    var cleaned = text.replace(/[^\d,\.]/g, '').replace(',', '.');
    var num = parseFloat(cleaned);
    return isNaN(num) ? 0 : Math.round(num * 100);
  }

  function updateProductCards() {
    var cards = document.querySelectorAll('.product-item');
    cards.forEach(function(card) {
      var priceEl = card.querySelector('.product-item__price');
      if (!priceEl) return;
      var isBox = card.querySelector('[data-product-type="Box"]') || card.dataset.productType === 'Box';
      if (isBox) return;
      var priceSpan = priceEl.querySelector('.price:not(.compare_at_price .price)');
      if (!priceSpan) priceSpan = priceEl.querySelector('ins .price, span.price');
      if (!priceSpan) return;
      if (!priceSpan.dataset.mbbOriginal) {
        priceSpan.dataset.mbbOriginal = priceSpan.innerHTML;
        priceSpan.dataset.mbbOriginalCents = extractCents(priceSpan.textContent);
      }
      var originalCents = parseInt(priceSpan.dataset.mbbOriginalCents, 10);
      if (!originalCents || isNaN(originalCents)) return;
      if (state.tier) {
        var discounted = Math.round(originalCents * (1 - state.tier.percent / 100));
        var compareEl = priceEl.querySelector('.mbb-compare');
        if (!compareEl) {
          compareEl = document.createElement('del');
          compareEl.className = 'compare_at_price mbb-compare';
          priceSpan.parentNode.insertBefore(compareEl, priceSpan);
        }
        compareEl.innerHTML = '<span class="price">' + priceSpan.dataset.mbbOriginal + '</span>';
        compareEl.style.display = '';
        priceSpan.innerHTML = formatPriceHTML(discounted);
        priceSpan.style.color = '#C62828';
        priceSpan.style.fontWeight = '700';
        var badge = card.querySelector('.mbb-badge');
        if (!badge) {
          badge = document.createElement('span');
          badge.className = 'mbb-badge';
          var imgContainer = card.querySelector('.product-item__image, .product-item__thumbnail');
          if (imgContainer) imgContainer.appendChild(badge);
        }
        badge.textContent = state.tier.label;
        badge.style.display = 'block';
      } else {
        priceSpan.innerHTML = priceSpan.dataset.mbbOriginal;
        priceSpan.style.color = '';
        priceSpan.style.fontWeight = '';
        var compareEl2 = priceEl.querySelector('.mbb-compare');
        if (compareEl2) compareEl2.style.display = 'none';
        var badge2 = card.querySelector('.mbb-badge');
        if (badge2) badge2.style.display = 'none';
      }
    });
  }

  function updateProgressBar() { /* deprecated — replaced by updateRewardsBars() */ }

  function computeExtrasTotal(cart) {
    if (!cart || !cart.items) return 0;
    var sum = 0;
    cart.items.forEach(function(item) {
      var isBox = (item.product_type === CONFIG.boxProductType || item.product_type === CONFIG.boxProductType.toLowerCase());
      if (!isBox) sum += item.final_line_price;
    });
    return sum;
  }

  /* --- Extra cards (grille bestsellers) : apply tier discount visually --- */
  function updateExtraCards() {
    document.querySelectorAll('.mbb-extra-card').forEach(function(card) {
      var price = parseInt(card.dataset.price, 10);
      var compareAt = parseInt(card.dataset.compareAt, 10) || 0;
      if (!price || isNaN(price)) return;
      var nowEl = card.querySelector('.mbb-extra-card__price-now');
      var wasEl = card.querySelector('.mbb-extra-card__price-was');
      var badge = card.querySelector('.mbb-extra-card__badge');
      if (!nowEl) return;
      if (!nowEl.dataset.mbbOriginal) nowEl.dataset.mbbOriginal = nowEl.innerHTML;
      if (wasEl && !wasEl.dataset.mbbOriginal) wasEl.dataset.mbbOriginal = wasEl.innerHTML;
      if (badge && !badge.dataset.mbbOriginal) badge.dataset.mbbOriginal = badge.textContent || '';
      var hadCompareAt = compareAt > price;

      if (state.tier) {
        var discounted = Math.round(price * (1 - state.tier.percent / 100));
        nowEl.innerHTML = formatPriceHTML(discounted);
        if (wasEl) { wasEl.innerHTML = nowEl.dataset.mbbOriginal; wasEl.hidden = false; }
        if (badge) { badge.textContent = state.tier.label; badge.hidden = false; }
        card.classList.add('is-discounted');
      } else {
        nowEl.innerHTML = nowEl.dataset.mbbOriginal;
        if (wasEl) {
          if (hadCompareAt) { wasEl.innerHTML = wasEl.dataset.mbbOriginal; wasEl.hidden = false; }
          else { wasEl.hidden = true; wasEl.innerHTML = ''; }
        }
        if (badge) {
          if (hadCompareAt && badge.dataset.mbbOriginal) { badge.textContent = badge.dataset.mbbOriginal; badge.hidden = false; }
          else { badge.hidden = true; badge.textContent = ''; }
        }
        card.classList.remove('is-discounted');
      }
    });
  }

  /* --- Unified rewards bar : tier + gift + shipping milestones on a single bar --- */
  /* MBB_REWARDS_PURE_START */
  function mbbEur(n) { return n.toFixed(2).replace('.', ',') + ' €'; }

  function mbbFillPos(sub, steps) {
    if (sub <= 0 || !steps.length) return 0;
    if (steps.length === 1) return sub >= steps[0].thr ? 1 : 0;
    var pts = [[0, 0]].concat(steps.map(function(step, i) {
      return [step.thr, i / (steps.length - 1)];
    }));
    // Liquid renders every enabled milestone in threshold order, so positions only increase.
    for (var i = 1; i < pts.length; i++) {
      // Skip every point at this threshold to reach the furthest tied disc.
      if (sub < pts[i][0]) {
        var a = pts[i - 1], b = pts[i];
        return a[1] + (b[1] - a[1]) * (sub - a[0]) / (b[0] - a[0]);
      }
    }
    return 1;
  }

  function mbbRewardsState(box, sub, steps) {
    var empty = box === 0 && sub === 0;
    var reached = steps.map(function(step) {
      return (step.on === 'box' ? box : sub) >= step.thr;
    });
    var next = -1;
    if (!empty) {
      steps.forEach(function(step, i) {
        if (!reached[i] && (next === -1 || step.thr < steps[next].thr)) next = i;
      });
    }
    var success = !empty && next === -1;
    var msg = 'Ajoutez une box pour débloquer vos avantages';
    if (success) {
      msg = 'Tous vos avantages sont débloqués';
    } else if (next !== -1) {
      var step = steps[next];
      var goals = {
        t1: "−5 % sur les pièces à l’unité",
        t2: "−10 % sur les pièces à l’unité",
        t3: "−15 % sur les pièces à l’unité",
        gift: 'votre produit offert',
        ship: 'la livraison offerte'
      };
      var ref = step.on === 'box' ? box : sub;
      msg = 'Plus que <b>' + mbbEur(step.thr - ref) + '</b>' +
        (step.on === 'box' ? ' de box' : '') + ' pour ' + goals[step.key];
    }
    return { reached: reached, next: next, fill: mbbFillPos(sub, steps), msg: msg, success: success, empty: empty };
  }
  /* MBB_REWARDS_PURE_END */

  function updateRewardsBars() {
    document.querySelectorAll('#mbb-rewards-bar').forEach(function(el) {
      var stepEls = el.querySelectorAll('.mbb-bar__step[data-step]');
      var steps = Array.prototype.map.call(stepEls, function(step) {
        return { key: step.dataset.step, thr: parseFloat(step.dataset.thr), on: step.dataset.on };
      });
      var box = state.maxBoxPrice / 100;
      var sub = ((state.cart && state.cart.original_total_price) || 0) / 100;
      var rewards = mbbRewardsState(box, sub, steps);
      stepEls.forEach(function(step, i) {
        step.classList.toggle('is-done', rewards.reached[i]);
        step.classList.toggle('is-next', i === rewards.next && !rewards.empty);
      });
      el.style.setProperty('--mbb-p', rewards.fill);
      var msg = el.querySelector('.mbb-bar__msg');
      if (msg.dataset.last !== rewards.msg) {
        msg.innerHTML = '<div>' + rewards.msg + '</div>';
        msg.dataset.last = rewards.msg;
      }
      msg.classList.toggle('is-success', rewards.success);
    });
  }

  function updateAddonDrawer() {
    var drawer = document.getElementById('mbb-addon-drawer');
    if (!drawer) return;
    drawer.style.display = state.maxBoxPrice > 0 ? 'block' : 'none';
    if (state.tier) {
      var subtitle = drawer.querySelector('.mbb-addon__subtitle');
      if (subtitle) subtitle.textContent = 'Profitez de ' + state.tier.label + ' sur ces extras !';
    }
  }

  /* --- Auto-apply discount code at checkout based on box price tier --- */
  function getActiveCodeFromCart(cart) {
    if (!cart || !cart.items) return null;
    /* Inspect line discounts to find which tier code is currently active */
    for (var i = 0; i < cart.items.length; i++) {
      var its = cart.items[i].discounts || [];
      for (var j = 0; j < its.length; j++) {
        var t = (its[j].title || '').toUpperCase();
        if (CONFIG.allCodes.indexOf(t) !== -1) return t;
      }
    }
    return null;
  }

  function applyDiscountCode(code) {
    state.syncInFlight = true;
    return _fetch('/discount/' + encodeURIComponent(code), {
      method: 'GET',
      credentials: 'same-origin',
      redirect: 'follow'
    }).catch(function(e) { console.warn('[MBB Engine] applyDiscountCode error:', e); })
      .then(function() { state.syncInFlight = false; });
  }

  function clearDiscountCode() {
    state.syncInFlight = true;
    return _fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: '' })
    }).catch(function(e) { console.warn('[MBB Engine] clearDiscountCode error:', e); })
      .then(function() { state.syncInFlight = false; });
  }

  function syncDiscountCode(cart) {
    if (state.syncInFlight) return Promise.resolve();
    var targetCode = state.tier ? state.tier.code : null;
    var currentCode = getActiveCodeFromCart(cart);
    if (currentCode === targetCode) {
      state.lastSyncedCode = targetCode;
      return Promise.resolve();
    }
    if (targetCode) {
      return applyDiscountCode(targetCode).then(function() {
        state.lastSyncedCode = targetCode;
        /* Refetch cart to reflect newly applied code in UI (without re-syncing) */
        return _fetch('/cart.js', { credentials: 'same-origin' })
          .then(function(r) { return r.json(); })
          .then(function(c) { state.cart = c; updateProductCards(); updateExtraCards(); updateProgressBar(); updateRewardsBars(); updateAddonDrawer(); });
      });
    } else if (currentCode) {
      /* No qualifying box → clear stale code */
      return clearDiscountCode().then(function() {
        state.lastSyncedCode = null;
      });
    }
    return Promise.resolve();
  }

  function update() {
    fetchCart(function(cart) {
      state.tier = calculateTier(cart);
      updateProductCards();
      updateExtraCards();
      updateProgressBar();
      updateRewardsBars();
      updateAddonDrawer();
      document.dispatchEvent(new CustomEvent('mbb:tierChanged', { detail: { tier: state.tier, maxBoxPrice: state.maxBoxPrice } }));
      /* After visual update, sync the actual Shopify discount code */
      syncDiscountCode(cart);
    });
  }

  var _fetch = window.fetch;
  window.fetch = function() {
    var result = _fetch.apply(this, arguments);
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url ? arguments[0].url : '');
    if (url.indexOf('/cart/') !== -1 && (url.indexOf('add') !== -1 || url.indexOf('change') !== -1 || url.indexOf('update') !== -1 || url.indexOf('clear') !== -1)) {
      result.then(function () { setTimeout(update, 400); }).catch(function () {});
    }
    return result;
  };

  /* --- Hook jQuery AJAX (Barberry theme uses $.ajax not fetch for cart ops) --- */
  function hookJqueryAjax() {
    if (window.jQuery && !window.jQuery.__mbbCartHooked) {
      window.jQuery(document).on('ajaxComplete.mbb', function(ev, xhr, settings) {
        var url = (settings && settings.url) || '';
        if (url.indexOf('/cart/') !== -1 && (url.indexOf('add') !== -1 || url.indexOf('change') !== -1 || url.indexOf('update') !== -1 || url.indexOf('clear') !== -1)) {
          setTimeout(update, 400);
        }
      });
      window.jQuery.__mbbCartHooked = true;
    }
  }
  /* --- Hook native XMLHttpRequest for any non-jQuery, non-fetch consumers --- */
  (function patchXHR() {
    if (window.XMLHttpRequest && !XMLHttpRequest.prototype.__mbbHooked) {
      var origOpen = XMLHttpRequest.prototype.open;
      var origSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function(method, url) { this.__mbbUrl = url || ''; return origOpen.apply(this, arguments); };
      XMLHttpRequest.prototype.send = function() {
        var url = this.__mbbUrl || '';
        if (url.indexOf('/cart/') !== -1 && /(add|change|update|clear)/.test(url)) {
          this.addEventListener('load', function() { setTimeout(update, 400); });
        }
        return origSend.apply(this, arguments);
      };
      XMLHttpRequest.prototype.__mbbHooked = true;
    }
  })();

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function() { hookJqueryAjax(); update(); }); } else { hookJqueryAjax(); update(); }
  document.addEventListener('shopify:section:load', function() { hookJqueryAjax(); setTimeout(update, 500); });
  window.MBBEngine = { update: update, getState: function() { return state; }, CONFIG: CONFIG };
})();
